// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var ref = allVue.ref;
var inject = allVue.inject;
import { classNames } from '@progress/kendo-vue-common';
import utils from './utils/utils';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, total, files as filesM, statusUploadFailed, statusUploaded } from './messages';
import { UploadListActionButton } from './UploadListActionButton';
/**
 * @hidden
 */

/**
 * Represents the default `UploadListMultiItem` component.
 */

var UploadListMultiItem = {
  name: 'KendoVueUploadListMultiItem',
  props: {
    files: Array,
    disabled: Boolean,
    async: Object
  },
  // @ts-ignore
  emits: {
    'cancel': null,
    'retry': null,
    'remove': null
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  methods: {
    onRetry: function onRetry(uid) {
      this.$emit('retry', uid);
    },
    onRemove: function onRemove(uid) {
      this.$emit('remove', uid);
    },
    onCancel: function onCancel(uid) {
      this.$emit('cancel', uid);
    },
    getFileValidationMessage: function getFileValidationMessage(file) {
      var localizationService = provideLocalizationService(this);
      var validationMessage = '';

      if (file.validationErrors && file.validationErrors.length > 0) {
        var messageKey = "upload." + file.validationErrors[0];
        validationMessage = localizationService.toLanguageString(messageKey, messages[messageKey]);
      }

      return validationMessage;
    },
    progress: function progress() {
      var files = this.$props.files;
      var sum = 0;
      files.forEach(function (file) {
        sum += file.progress || 0;
      });
      return sum / files.length;
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    var kendoLocalizationService = inject('kendoLocalizationService', {});
    return {
      v3: v3,
      kendoLocalizationService: kendoLocalizationService
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
        files = _a.files,
        disabled = _a.disabled,
        async = _a.async;
    var itemClassName = classNames('k-file-multiple');

    var _b = utils.getFileStatus(files),
        isUploaded = _b[1],
        isUploadFailed = _b[2],
        isUploadValidationFailed = _b[3];

    var localizationService = provideLocalizationService(this);
    var totalMessage = localizationService.toLanguageString(total, messages[total]);
    var filesMessage = localizationService.toLanguageString(filesM, messages[filesM]);
    var uploadFailedMessage = localizationService.toLanguageString(statusUploadFailed, messages[statusUploadFailed]);
    var successMessage = localizationService.toLanguageString(statusUploaded, messages[statusUploaded]);
    var progress = this.progress();
    var showProgressBar = !isUploadValidationFailed && !isUploaded && !isUploadFailed;

    var mapFiles = function mapFiles() {
      return files.map(function (file) {
        return h("span", {
          key: file.name,
          "class": 'k-file-name-size-wrapper'
        }, [h("span", {
          "class": 'k-file-name',
          title: file.name,
          attrs: this.v3 ? undefined : {
            title: file.name
          }
        }, [file.name]), utils.fileHasValidationErrors(file) ? h("span", {
          "class": 'k-file-validation-message k-text-error'
        }, [this.getFileValidationMessage(file)]) : h("span", {
          key: file.name + "-size",
          "class": 'k-file-size'
        }, [utils.getTotalFilesSizeMessage([file])])]);
      }, this);
    };

    return h("div", {
      "class": itemClassName
    }, [h("div", {
      "class": 'k-progressbar',
      style: {
        transition: 'opacity 1s ease-in-out',
        opacity: showProgressBar ? 1 : 0
      }
    }, [h("span", {
      "class": 'k-progress',
      style: {
        width: (progress || 0) + '%'
      }
    })]), h("span", {
      "class": 'k-multiple-files-group-wrapper'
    }, [h("span", {
      "class": 'k-file-group k-icon k-i-copy'
    })]), h("span", {
      "class": "k-multiple-files-wrapper"
    }, [mapFiles.call(this), !isUploadFailed ? progress !== 100 ? h("span", {
      "class": 'k-file-information'
    }, [totalMessage + ": " + files.length + " " + filesMessage + ", " + utils.getTotalFilesSizeMessage(files)]) : h("span", {
      "class": 'k-file-information k-text-success'
    }, [files.length + " " + successMessage]) : h("span", {
      "class": 'k-file-validation-message k-text-error'
    }, [files.length + " " + uploadFailedMessage])]), // @ts-ignore  function children
    h(UploadListActionButton, {
      uid: files[0].uid,
      attrs: this.v3 ? undefined : {
        uid: files[0].uid,
        status: files[0].status,
        progress: progress,
        files: files,
        disabled: disabled,
        async: async
      },
      status: files[0].status,
      progress: progress,
      files: files,
      disabled: disabled,
      async: async,
      onCancel: this.onCancel,
      on: this.v3 ? undefined : {
        "cancel": this.onCancel,
        "remove": this.onRemove,
        "retry": this.onRetry
      },
      onRemove: this.onRemove,
      onRetry: this.onRetry
    })]);
  }
};
var UploadListMultiItemVue3 = UploadListMultiItem;
export { UploadListMultiItem, UploadListMultiItemVue3 };